import React from "react"
import Spacer from "../../design-system/atoms/layout-primitives/spacer"
import {
  FadeIn,
  FadeInBottom,
} from "../../design-system/styles/animations.styles"
import Grid from "../shared/grid"
import SolutionsSlides from "./solutions-slide"
import {
  Container,
  DescriptionContainer,
  DescriptionText,
  Title,
  TitleWrapper,
} from "./solutions.style"

const SolutionsContainer = () => {
  return (
    <>
      <Spacer height={{ sm: "64px", lg: "128px" }} />
      <Container>
        <Grid>
          <TitleWrapper>
            <Title animation={FadeIn} duration="1.5s">
              <span>Innovative solutions</span> across multiple spaces
            </Title>
          </TitleWrapper>
          <DescriptionContainer>
            <DescriptionText animation={FadeInBottom} duration="1.5s">
              Mappedin’s flexible platform enables you to build indoor mapping
              solutions for any use case. We help bring your vision to life by
              providing developer tools, pre-built applications, and custom
              development resources.
            </DescriptionText>
          </DescriptionContainer>
        </Grid>
        <SolutionsSlides />
      </Container>
    </>
  )
}

export default SolutionsContainer
